<me-loader
  [style]="{ position: 'absolute', left: '50%', top: '50%' }"
  size="large"
></me-loader>
